export default __webpack_public_path__ + "static/media/english-to-hindi-screenshot-05.bd9ce062.png";